import CssBaseline from '@mui/material/CssBaseline'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import type { PropsWithChildren } from 'react'

export const AppThemeProvider = ({ children }: PropsWithChildren) => {
	const theme = createTheme({
		breakpoints: {
			values: {
				xs: 0,
				sm: 470,
				md: 900,
				lg: 1096,
				xl: 1536
			}
		},
		typography: {
			fontFamily: '"Manrope", "Roboto", sans-serif'
		},
		palette: {
			background: {
				default: '#EDF0F5'
			},
			text: {
				primary: '#17191C',
				secondary: '#5F6671',
				accent: '#0060E6'
			},
			surface: {
				primary: '#FFFFFF',
				secondary: '#F4F6F9',
				light40: 'rgba(255, 255, 255, 0.4)'
			},
			icon: {
				accent: '#0060E6',
				white: '#FFFFFF'
			},
			border: {
				accent: '#0060E6'
			},
			overlay: {
				dark80: 'rgba(0, 0, 0, 0.8)'
			}
		},
		spacing: '0.25rem',
		shape: { borderRadius: ' 0.375rem' },
		components: {
			MuiPopover: {
				defaultProps: {
					disableScrollLock: true
				}
			},

			MuiCard: {
				styleOverrides: {
					root: () => ({
						borderRadius: '16px',
						boxShadow: '0px 6px 32px rgba(0, 0, 0, 0.06)'
					})
				},
				variants: [
					{
						props: { variant: 'standart' },
						style: ({ theme }) => ({
							backgroundColor: theme.palette.surface.primary
						})
					},
					{
						props: { variant: 'colored' },
						style: ({ theme }) => ({
							backgroundColor: theme.palette.surface.secondary
						})
					}
				]
			},
			MuiDialog: {
				defaultProps: {
					disableScrollLock: true
				},
				styleOverrides: {
					paper: {
						margin: '40px'
					}
				}
			},

			MuiBackdrop: {
				styleOverrides: {
					root: ({ theme }) => ({
						backgroundColor: theme.palette.overlay.dark80
					})
				}
			},
			MuiDivider: {
				styleOverrides: {
					root: ({ theme }) => ({
						borderColor: theme.palette.text.accent
					})
				}
			}
		}
	})

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			{children}
		</ThemeProvider>
	)
}
